import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { LoaderService } from './utils/loader.service';
import { SharedServiceService } from './shared/services/shared-service.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './authentication/auth.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'vendor-portal-frontend';
  showLoader: boolean;
  showSidepanel = false;
  isMaximized = false;

  chatID: string = this.sharedService.chatID;;
  engageUrl: any = this.sharedService.engageUrl;
  engage_token: any = this.sharedService.engage_token;
  iframeEndpoint: string = undefined;

  private isDragging = false;
  private currentX: number;
  private initialX: number;
  private xOffset: number; // Will be set in ngAfterViewInit
  private dragThreshold = 5; // Pixels to consider a drag
  private hasDragged = false;
  private startX: number;

  loading: boolean = true; // Initially show loading overlay

  constructor(
    public loaderService: LoaderService,
    private sharedService: SharedServiceService,
    private toasterService: ToastrService,
    private renderer: Renderer2,
    private el: ElementRef,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.subscribeToObservables();
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.loaderService.isLoading;
    this.checkAiChatId();
  }

  ngAfterViewInit() {
    // Initialize xOffset based on initial position (right: 30px)
    const button = this.el.nativeElement.querySelector('.floating-button');
    const buttonWidth = button.offsetWidth;
    this.xOffset = window.innerWidth - buttonWidth - 30; // Convert right: 30px to left-based coordinate
  }

  checkAiChatId() {
    const chatId = localStorage.getItem('ai-chat-id');
    if (chatId) {
      this.loading = false;
      this.sharedService.chatID = chatId;
      this.chatID = chatId;
      this.engage_token = localStorage.getItem('token');
      this.iframeEndpoint = 'dashboard/chat/liveChat/';
      this.sharedService.engageUrl = this.getSafeUrl(
        chatId,
        this.engage_token,
        this.iframeEndpoint
      );
    }
  }

  subscribeToObservables() {
    // Subscribe to observables to get real-time updates
    this.sharedService.engage_token$.subscribe((engage_token) => {
      this.engage_token = engage_token;
    });

    this.sharedService.iframeEndpoint$.subscribe((iframeEndpoint) => {
      this.iframeEndpoint = iframeEndpoint;
    });

    this.sharedService.engageUrl$.subscribe((engageUrl) => {
      this.engageUrl = engageUrl;
    });
  }

  onButtonClick(event: MouseEvent) {
    if (!this.chatID || !localStorage.getItem('ai-chat-id')) {
      this.toasterService.error('You do not have chat id created for AI.', 'Error');
    }
    if (!this.hasDragged) {
      this.toggleSidepanel();
    }
  }

  getSafeUrl(chat_id: any, engage_token: string, endpoint: string) {
    if (chat_id) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.safeUrl +
        endpoint +
        chat_id +
        "?token=" +
        engage_token +
        "&iframe=true"
      );
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        environment.safeUrl +
        endpoint +
        "?token=" +
        engage_token +
        "&iframe=true"
      );
    }
  }

  onIframeLoad(iframeRef: HTMLIFrameElement) {
    if (iframeRef?.src !== "") {
      this.loading = false;
    }
  }

  toggleSidepanel() {
    if (this.chatID) {
      this.showSidepanel = !this.showSidepanel;
      if (this.showSidepanel) {
        this.loading = true; //show loader until ifram has loaded
      }
    }

  }

  maximizeSidepanel() {
    this.isMaximized = true;
  }

  minimizeSidepanel() {
    this.isMaximized = false;
  }

  closeSidepanel() {
    this.showSidepanel = false;
    this.isMaximized = false;
  }

  startDragging(event: MouseEvent) {
    this.initialX = event.clientX - this.xOffset;
    this.startX = event.clientX;
    this.isDragging = true;
    this.hasDragged = false;

    // Add event listeners for mousemove and mouseup
    this.renderer.listen('document', 'mousemove', (e) => this.drag(e));
    this.renderer.listen('document', 'mouseup', () => this.stopDragging());
  }

  drag(event: MouseEvent) {
    if (this.isDragging) {
      event.preventDefault();
      this.currentX = event.clientX - this.initialX;
      this.xOffset = this.currentX;

      // Check if drag distance exceeds threshold
      if (Math.abs(event.clientX - this.startX) > this.dragThreshold) {
        this.hasDragged = true;
      }

      // Restrict to horizontal movement and ensure button stays within viewport
      const buttonWidth = this.el.nativeElement.querySelector('.floating-button').offsetWidth;
      const maxX = window.innerWidth - buttonWidth;
      this.xOffset = Math.max(0, Math.min(this.xOffset, maxX));

      // Set the 'right' style based on xOffset
      this.renderer.setStyle(
        this.el.nativeElement.querySelector('.floating-button'),
        'right',
        `${window.innerWidth - this.xOffset - buttonWidth}px`
      );
    }
  }

  stopDragging() {
    this.isDragging = false;
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }
}
